import { render, staticRenderFns } from "./SeminarCard.vue?vue&type=template&id=5f1f12cc&scoped=true&"
import script from "./SeminarCard.vue?vue&type=script&lang=ts&"
export * from "./SeminarCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f12cc",
  null
  
)

export default component.exports